(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduceMotion) return;

  var layers = Array.prototype.slice.call(document.querySelectorAll("[data-chinni-parallax]"));
  if (!layers.length) return;

  var MOBILE_BREAKPOINT = 749;
  var MAX_TRAVEL_DESKTOP = 8; // px, vertical only
  var MAX_TRAVEL_MOBILE = 4; // px, vertical only
  var SCALE_DESKTOP = 1.05; // just enough overscan to cover MAX_TRAVEL_DESKTOP
  var SCALE_MOBILE = 1.03; // just enough overscan to cover MAX_TRAVEL_MOBILE

  var ticking = false;

  function settings() {
    var mobile = window.innerWidth <= MOBILE_BREAKPOINT;
    return {
      travel: mobile ? MAX_TRAVEL_MOBILE : MAX_TRAVEL_DESKTOP,
      scale: mobile ? SCALE_MOBILE : SCALE_DESKTOP
    };
  }

  function update() {
    ticking = false;
    var cfg = settings();
    var vh = window.innerHeight;

    layers.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var total = vh + rect.height;
      if (total <= 0) return;

      var traveled = vh - rect.top;
      var progress = traveled / total;
      progress = Math.min(1, Math.max(0, progress));

      var offset = (progress - 0.5) * 2 * cfg.travel;
      // scaleY (not scale/scaleX) + translateY only: vertical overscan and
      // vertical travel, with zero horizontal enlargement — a plain scale()
      // here previously stretched the layer past the viewport on both
      // sides, which is what caused the page-wide horizontal overflow.
      el.style.transform = "scaleY(" + cfg.scale + ") translateY(" + offset.toFixed(2) + "px)";
    });
  }

  function onScrollOrResize() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  window.addEventListener("scroll", onScrollOrResize, { passive: true });
  window.addEventListener("resize", onScrollOrResize);
  update();
})();
